import React, { Component, Fragment } from 'react';
import Marker from './Marker';
import GoogleMap from './GoogleMap';

// Return map bounds based on list of places
const getMapBounds = (map, maps, places) => {
    const bounds = new maps.LatLngBounds();

    places.forEach((place) => {
        if (place.lat === null || place.lng === null)
            return null
        bounds.extend(new maps.LatLng(
            place.lat,
            place.lng,
        ));
    });
    return bounds;
};

// Re-center map when resizing the window
const bindResizeListener = (map, maps, bounds) => {
    maps.event.addDomListenerOnce(map, 'idle', () => {
        maps.event.addDomListener(window, 'resize', () => {
            map.fitBounds(bounds);
        });
    });
};

// Fit map to its bounds after the api is loaded
const apiIsLoaded = (map, maps, places) => {
    // Get bounds by our places
    const bounds = getMapBounds(map, maps, places);
    // Fit map to bounds
    map.fitBounds(bounds);
    // Bind the resize listener
    bindResizeListener(map, maps, bounds);
};

class Main extends Component {
    state = {
        places: [],
        zoom: 16
    };

    //   componentDidMount() {
    //     fetch('places.json')
    //       .then(response => response.json())
    //       .then(data => this.setState({ places: data.results }));
    //   }

    render() {
        let center = null;
        let places = [];
        if (!this.props.lat && !this.props.lng) {

            return (
                <div>

                </div>
            )
        } else {
            center = {
                lat: parseFloat(this.props.lat),
                lng: parseFloat(this.props.lng)
            };

            places = [{
                id: this.props.id,
                name: this.props.name,
                lat: parseFloat(this.props.lat),
                lng: parseFloat(this.props.lng)
            }];

            return (
                <div style={{
                    height: 500
                }}>
                    <GoogleMap
                        zoom={16}
                        center={center}
                    // yesIWantToUseGoogleMapApiInternals
                    // onGoogleApiLoaded={({ map, maps }) => apiIsLoaded(map, maps, this.props.places)}
                    >
                        {
                            places.map(place => (
                                <Marker
                                    key={place.id}
                                    text={place.name}
                                    lat={place.lat}
                                    lng={place.lng}
                                />
                            ))
                        }
                    </GoogleMap>
                </div>
            );
        }

    }
}

export default Main;


// WEBPACK FOOTER //
// ./src/containers/GoogleMap/Main.js